
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-service/login",
      function () {
        return require("private-next-pages/customer-service/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-service/login"])
      });
    }
  